import React from 'react';
import { CircleCheckIcon } from 'lucide-react';
import type { Tool } from '../../types/tools';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
import { ToolOutputPreview } from './ToolOutputPreview';

/** "What you get" list beside a full illustrative sample deliverable. */
export function ToolOutputs({
  tool
}: {
  tool: Tool;
}) {
  return <section aria-labelledby="outputs-heading" className="border-b border-hairline-soft bg-surface" data-id="element-1246" data-mp="4x3zskcw2q5">
      <div className="mx-auto grid w-full max-w-[1320px] gap-12 px-4 py-20 sm:px-6 lg:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)] lg:gap-16 lg:px-8 lg:py-24" data-id="element-1247" data-mp="3s97qqco3avjh">
        <div data-id="element-1248" data-mp="3ngemdpwj9p7x">
          <SectionHeading eyebrow="What you get" headingId="outputs-heading" title="Deliverables built for analyst review" description="Each output is structured so your team can check the reasoning, see the sources and decide what to do next." data-id="element-1249" data-mp="3nfwe1uwljkjn" />
          <ul className="mt-10 flex flex-col gap-5" data-id="element-1250" data-mp="f0l5h9yaibqc">
            {tool.outputs.map((output, index) => <Reveal key={output.title} as="li" delay={index * 0.04} className="flex gap-3" data-id="element-1251" data-mp="2m2bhow5eyux4" data-mpi={index}>
                <CircleCheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-lime" aria-hidden="true" data-id="element-1252" data-mp="28awppztj3jdx" />
                <div data-id="element-1253" data-mp="2cci7nzkx6nuz">
                  <h3 className="text-[15px] font-semibold text-text-primary" data-id="element-1254" data-mp="2cc074qr85nh9">{output.title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-text-secondary" data-id="element-1255" data-mp="1yc7gevfp779a">{output.body}</p>
                </div>
              </Reveal>)}
          </ul>
        </div>

        <Reveal delay={0.08} className="min-w-0 lg:sticky lg:top-24 lg:self-start" data-id="element-1256" data-mp="1pcc06c7acm2e">
          <h3 className="mb-4 text-sm font-semibold uppercase tracking-[0.08em] text-text-secondary" data-id="element-1257" data-mp="1pef13r9z7zlw">
            Illustrative output: {tool.preview.kind.toLowerCase()}
          </h3>
          <ToolOutputPreview tool={tool} variant="full" data-id="element-1258" data-mp="3jnz4cpc2hyvg" />
        </Reveal>
      </div>
    </section>;
}